import React from 'react';

export const Footer = () => {
    return <div className='sticky bottom-0 text-center p-2 mt-10 border-t bg-[#ffffff] dark:bg-[#171717] dark:border-gray-700'>
        <h1>@2022 Gaggle, Inc.</h1>
    </div>;
};
